import { AuthenticationService } from '@shared/authentication';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { environment } from '@environment/environment';
import { map, of, switchMap, take } from 'rxjs';

export const Auth0TenantGuard: CanActivateFn = () => {
  const auth = inject(AuthenticationService);

  return auth.isAuthenticated$.pipe(
    take(1),
    switchMap(authenticated =>
      authenticated
        ? auth.twinUser$.pipe(
            take(1),
            map(user => user?.currentTenant === environment.auth0.tenantId)
          )
        : of(false)
    )
  );
};
